var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-mypage"},[_c('div',{staticClass:"p-mypage__free-area__header"},[_c('switch-by-ua',{attrs:{"content":_vm.headerFreeArea}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }